import { useRequest } from 'ahooks';
import { Link } from 'react-router-dom';
import { getActList } from './PlanDetail/service.js';

// biome-ignore lint/complexity/noBannedTypes: <explanation>
export type HomePageProps = {};

export function HomePage(props: HomePageProps) {
  const { data } = useRequest(getActList);
  return (
    <div className='pt-safe'>
      <b className='px-4 py-2 text-gray-400 text-lg block mb-2'>我的行程</b>

      {data?.map((i) => (
        <Link to={`/plan/${i.id}`} key={i.id}>
          <article
            className='mx-4 rounded-[24px] mb-4 p-6'
            style={{ backgroundColor: i.bgColor }}
          >
            <b className='text-gray-800 text-xl font-semibold'>{i.title}</b>
          </article>
        </Link>
      ))}

      {/* <PushSubscriptionToggle /> */}
    </div>
  );
}

export default HomePage;
